export default __webpack_public_path__ + "static/media/offer_banner-2.1212d913.jpg";